// =================================================================
// AMG Enums (PSD §3.1)
// =================================================================
export var Agent;
(function (Agent) {
    Agent["Gentamicin"] = "gentamicin";
    Agent["Tobramycin"] = "tobramycin";
    Agent["Amikacin"] = "amikacin";
    // Phase 3
    Agent["Plazomicin"] = "plazomicin";
    Agent["Streptomycin"] = "streptomycin";
    Agent["Neomycin"] = "neomycin";
})(Agent || (Agent = {}));
export var Strategy;
(function (Strategy) {
    Strategy["ExtendedInterval"] = "extended-interval";
    Strategy["Traditional"] = "traditional";
    Strategy["Dialysis"] = "dialysis";
    Strategy["Synergy"] = "synergy";
})(Strategy || (Strategy = {}));
export var Sex;
(function (Sex) {
    Sex["Male"] = "male";
    Sex["Female"] = "female";
})(Sex || (Sex = {}));
export var Indication;
(function (Indication) {
    Indication["GramNegativeSepsis"] = "gn-sepsis";
    Indication["ComplicatedUTI"] = "complicated-uti";
    Indication["Pyelonephritis"] = "pyelonephritis";
    Indication["IntraAbdominal"] = "intra-abdominal";
    Indication["Pneumonia"] = "pneumonia-hap";
    Indication["Endocarditis"] = "endocarditis-synergy";
    Indication["Bacteremia"] = "bacteremia";
    Indication["Meningitis"] = "meningitis";
    Indication["FebrileNeutropenia"] = "febrile-neutropenia";
    Indication["Other"] = "other";
})(Indication || (Indication = {}));
export var WeightRule;
(function (WeightRule) {
    WeightRule["UseABW"] = "abw-less-than-ibw";
    WeightRule["UseIBW"] = "abw-at-ibw";
    WeightRule["UseAdjBW"] = "abw-greater-than-120";
    WeightRule["ManualOverride"] = "manual-override";
})(WeightRule || (WeightRule = {}));
export var NomogramSource;
(function (NomogramSource) {
    NomogramSource["Hartford"] = "hartford";
    NomogramSource["BarnesJewish"] = "barnes-jewish";
    NomogramSource["UrbanCraig"] = "urban-craig";
    NomogramSource["Rochester"] = "rochester";
})(NomogramSource || (NomogramSource = {}));
export var IntervalRecommendation;
(function (IntervalRecommendation) {
    IntervalRecommendation["Q24h"] = "q24h";
    IntervalRecommendation["Q36h"] = "q36h";
    IntervalRecommendation["Q48h"] = "q48h";
    IntervalRecommendation["Q12h"] = "q12h";
    IntervalRecommendation["Hold"] = "hold";
    IntervalRecommendation["ExitExtendedInterval"] = "exit-ei";
})(IntervalRecommendation || (IntervalRecommendation = {}));
export var ConfidenceStatus;
(function (ConfidenceStatus) {
    ConfidenceStatus["Empiric"] = "empiric";
    ConfidenceStatus["LevelInformed"] = "level-informed";
    ConfidenceStatus["OutOfRange"] = "out-of-range";
    ConfidenceStatus["RequiresReview"] = "requires-review";
})(ConfidenceStatus || (ConfidenceStatus = {}));
export var PopulationMode;
(function (PopulationMode) {
    PopulationMode["Standard"] = "standard-adult";
    PopulationMode["Hemodialysis"] = "hemodialysis";
    PopulationMode["CVVHD_CRRT"] = "cvvhd-crrt";
    PopulationMode["PeritonealDialysis"] = "peritoneal-dialysis";
    PopulationMode["Obesity"] = "obesity";
    PopulationMode["ElderlyHighRisk"] = "elderly-high-risk";
    PopulationMode["AugmentedRenalClearance"] = "augmented-renal-clearance";
    PopulationMode["NeonatalPediatric"] = "neonatal-pediatric";
    PopulationMode["CysticFibrosis"] = "cystic-fibrosis";
    PopulationMode["Pregnancy"] = "pregnancy";
    PopulationMode["BurnsAscites"] = "burns-ascites";
})(PopulationMode || (PopulationMode = {}));
export var FluidStatus;
(function (FluidStatus) {
    FluidStatus["Euvolemic"] = "euvolemic";
    FluidStatus["Hypervolemic"] = "hypervolemic";
    FluidStatus["Hypovolemic"] = "hypovolemic";
})(FluidStatus || (FluidStatus = {}));
export var RenalStability;
(function (RenalStability) {
    RenalStability["Stable"] = "stable";
    RenalStability["Unstable"] = "unstable";
})(RenalStability || (RenalStability = {}));
export var UnitSystem;
(function (UnitSystem) {
    UnitSystem["Conventional"] = "conventional";
    UnitSystem["SI"] = "si";
})(UnitSystem || (UnitSystem = {}));
export var LevelType;
(function (LevelType) {
    LevelType["Peak"] = "peak";
    LevelType["Trough"] = "trough";
    LevelType["Random"] = "random";
    LevelType["MidInterval"] = "mid-interval";
})(LevelType || (LevelType = {}));
export var ToxicityRisk;
(function (ToxicityRisk) {
    ToxicityRisk["Low"] = "low";
    ToxicityRisk["Moderate"] = "moderate";
    ToxicityRisk["High"] = "high";
})(ToxicityRisk || (ToxicityRisk = {}));
export var EIEligibility;
(function (EIEligibility) {
    EIEligibility["Eligible"] = "eligible";
    EIEligibility["Borderline"] = "borderline";
    EIEligibility["Ineligible"] = "ineligible";
    EIEligibility["Contraindicated"] = "contraindicated";
})(EIEligibility || (EIEligibility = {}));
export var PKSource;
(function (PKSource) {
    PKSource["Population"] = "population";
    PKSource["PatientSpecific"] = "patient-specific";
})(PKSource || (PKSource = {}));
export var RenalAssaySystem;
(function (RenalAssaySystem) {
    RenalAssaySystem["Conventional"] = "conventional";
    RenalAssaySystem["SI"] = "si";
})(RenalAssaySystem || (RenalAssaySystem = {}));
//# sourceMappingURL=enums.js.map